import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

// 开发没时间补充 ts 类型了
interface InitialState {
  unReadCount: number;
  initiatedMeeting: any[];
  receivedMeeting: any[];
  initiatedParams: any;
  receivedParams: any;
  initiatedMeetingloading: boolean;
  receivedMeetingloading: boolean;
}

// rxjs + reduxjs = 异步的jQuery
const initialState = {
  unReadCount: 0,
  initiatedMeeting: [],
  receivedMeeting: [],
  initiatedParams: {
    pageNo: 1,
    size: 20,
    total: 100
  },
  receivedParams: {
    pageNo: 1,
    size: 20,
    total: 100
  },
  initiatedMeetingloading: false,
  receivedMeetingloading: false
} as InitialState;

/**
 * 审批的全局状态
 */
const approval = createSlice({
  name: 'approval',
  initialState: initialState,
  reducers: {
    setUnReadCount(state, action: PayloadAction<number>) {
      state.unReadCount = action.payload;
    },
    setInitiatedMeeting(state, action: PayloadAction<any>) {
      action.payload.size = action.payload.pageSize;
      state.initiatedParams = action.payload;
      if (action.payload.pageNo === 1) state.initiatedMeeting = action.payload.data;
      else state.initiatedMeeting = state.initiatedMeeting.concat(action.payload.data);
    },
    setReceivedMeeting(state, action: PayloadAction<any>) {
      action.payload.size = action.payload.pageSize;
      state.receivedParams = action.payload;
      if (action.payload.pageNo === 1) state.receivedMeeting = action.payload.data;
      else state.receivedMeeting = state.receivedMeeting.concat(action.payload.data);
    },
    setInitiatedMeetingLoading(state, action: PayloadAction<boolean>) {
      state.initiatedMeetingloading = action.payload;
    },
    setReceivedMeetingLoading(state, action: PayloadAction<boolean>) {
      state.receivedMeetingloading = action.payload;
    },
    setReceivedMeetingDetail(state, action: PayloadAction<any>) {
      const index = state.receivedMeeting.findIndex((val) => val.meetingNo === action.payload.meetingNo);

      if (index < 0) {
        state.receivedMeeting.push(action.payload);
      } else {
        state.receivedMeeting = state.receivedMeeting.map((val) => {
          if (val.meetingNo === action.payload.meetingNo) return action.payload;
          return val;
        });
      }
    },
    setInitiatedMeetingDetail(state, action: PayloadAction<any>) {
      const index = state.initiatedMeeting.findIndex((val) => val.meetingNo === action.payload.meetingNo);

      if (index < 0) {
        state.initiatedMeeting.push(action.payload);
      } else {
        state.initiatedMeeting = state.initiatedMeeting.map((val) => {
          if (val.meetingNo === action.payload.meetingNo) return action.payload;
          return val;
        });
      }

      console.log('setInitiatedMeetingDetail', state.initiatedMeeting);
    },
    setLocaleApprovalMeetingRead(state, action: PayloadAction<string>) {
      // 设置为已读
      state.receivedMeeting = state.receivedMeeting.map((meeting) => {
        if (meeting.meetingNo === action.payload) {
          meeting.isRead = true;
        }
        return meeting;
      });
    }
  }
});

export default approval.reducer;

export const getUnreadCount = createAction('approval/getUnreadCount');
export const getInitiatedMeeting = createAction<any>('approval/getInitiatedMeeting');
export const getReceivedMeeting = createAction<any>('approval/getReceivedMeeting');
export const getInitiatedMeetingDetail = createAction<any>('approval/getInitiatedMeetingDetail');
export const getReceivedMeetingDetail = createAction<any>('approval/getReceivedMeetingDetail');
export const doApprovalMeeting = createAction<any>('approval/doApprovalMeeting');
export const setApprovalMeetingRead = createAction<any>('approval/setApprovalMeetingRead');
export const gotoApprovalMeetingDetail = createAction<any>('approval/gotoApprovalMeetingDetail');
export const getinitiatedMeetingDetail = createAction<any>('approval/getinitiatedMeetingDetail');

export const {
  setUnReadCount,
  setInitiatedMeeting,
  setReceivedMeeting,
  setInitiatedMeetingLoading,
  setReceivedMeetingLoading,
  setReceivedMeetingDetail,
  setLocaleApprovalMeetingRead,
  setInitiatedMeetingDetail
} = approval.actions;
